import { ValueType } from 'modules/queryBuilder/legacyQueryBuilder/types';
import { createValueTypeDropdownOption } from './createValueTypeDropdownOption';

export const getValueTypeDropdownOptions = ({
  showContactProperty,
  showTriggerProperty,
}: {
  showContactProperty: boolean;
  showTriggerProperty: boolean;
}) => [
  createValueTypeDropdownOption(ValueType.Custom),
  ...(showContactProperty ? [createValueTypeDropdownOption(ValueType.Contact)] : []),
  ...(showTriggerProperty ? [createValueTypeDropdownOption(ValueType.Trigger)] : []),
];
